module.exports = __webpack_public_path__ + "img/warn.2f8c2e92.png";